var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('h1',{attrs:{"id":"video-name"}},[_vm._v("\n    "+_vm._s(_vm.decodedName)+"\n")])}
var staticRenderFns = []

export { render, staticRenderFns }